import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="705" viewBox="0 0 16 705" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" {...props}><path d="M14.76 1C.06 150.79-2.44 335.6 5.26 703.72M7.6 7.92c6.8 230.35 6.66 457.12-.16 684.42" stroke="#000" strokeWidth="2" strokeLinecap="round" /></svg>);